import React from "react"
import { NavLink } from "react-router-dom"
import { Home, Map, Receipt, CreditCard, Info } from "lucide-react"

import styles from "./portal-nav.module.scss"

/**
 * Section navigation for the portal. A horizontal, scrollable pill bar that
 * works equally on mobile and desktop.
 *
 * Links point at the existing routes for now; sections are reskinned chunk by
 * chunk (itinerary -> timeline, then payments + practical info). The "Info"
 * tab currently lands on check-in/out times, which is where the practical
 * info will be consolidated.
 */
export default function PortalNav({ base }) {
	const items = [
		{ to: base, exact: true, label: "Home", Icon: Home },
		{ to: `${base}/itinerary`, label: "Itinerary", Icon: Map },
		{ to: `${base}/pricing`, label: "Pricing", Icon: Receipt },
		{ to: `${base}/payments`, label: "Payments", Icon: CreditCard },
		// Messages — hidden from the nav for now; route + logic kept intact.
		// { to: `${base}/messages`, label: "Messages", Icon: MessageSquare },
		{ to: `${base}/checkin`, label: "Info", Icon: Info },
	]

	return (
		<nav className={styles.nav}>
			<div className={styles.navInner}>
				{items.map(({ to, exact, label, Icon }) => (
					<NavLink
						key={to}
						to={to}
						exact={exact}
						className={styles.link}
						activeClassName={styles.active}>
						<Icon size={17} />
						<span>{label}</span>
					</NavLink>
				))}
			</div>
		</nav>
	)
}
